import { Link } from 'react-router';

import { addDate, beginningOfSemester, endOfSemester, subtractDate } from 'my-core/date-utils';
import { useLocalStorage } from 'my-core/hooks';
import { courseClassRepApplyPath } from 'my-core/routes';

import CustomColorButton from 'my-elements/CustomColorButton';

import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';

import { faTimes } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

let isInClassRepRecruitmentPeriod;
function getIsInClassRepRecruitmentPeriod() {
  return (isInClassRepRecruitmentPeriod ||=
    new Date() < addDate(beginningOfSemester(), { days: 50 }) ||
    new Date() > subtractDate(endOfSemester(), { days: 10 }));
}
export default function StudentCoursePageClassRepApplicationBanner({ course }) {
  const { setValue: setCourseBannerConfig, value: courseBannerConfig } = useLocalStorage('course_page_cr_banner_cfg');
  const bannerDismissedAt = courseBannerConfig?.[course?.id];

  function hideBanner() {
    setCourseBannerConfig({ ...courseBannerConfig, [course.id]: Date.now() });
  }

  if (!getIsInClassRepRecruitmentPeriod()) return null;
  if (bannerDismissedAt && Date.now() - +bannerDismissedAt < 50 * 24 * 3600_000) return null;

  return (
    <div
      css={({ palette, shape, spacing }) => ({
        borderRadius: shape.borderRadius,
        background: `linear-gradient(to right, ${palette.primary.main}, ${palette.primary.dark})`,
        padding: spacing(3),
        display: 'flex',
        alignItems: 'center',
        gap: spacing(2),
        color: palette.primary.contrastText,
        '& > .content': {
          flex: 1,
          '& > * + *': { marginTop: spacing(1) },
        },
        '& > .actions': {
          flexShrink: 0,
          display: 'flex',
          alignSelf: 'stretch',
          flexDirection: 'column',
          alignItems: 'flex-end',
          justifyContent: 'space-between',
          gap: spacing(2),
          '& .MuiIconButton-root': { margin: spacing(-1, -1, 0, 0), color: 'inherit' },
        },
      })}
    >
      <div className="content">
        <Typography sx={{ typography: ['subtitle1', 'h6'] }} variant="h6">
          Want a free subscription and 50% off Grade Boosters?
        </Typography>
        <Typography sx={{ typography: ['body2', 'body1'] }}>
          Become a class representative and get free study help for 15 minutes of work per week!
        </Typography>
      </div>
      <div className="actions">
        <IconButton onClick={hideBanner} size="small">
          <FontAwesomeIcon icon={faTimes} size="lg" />
        </IconButton>
        <CustomColorButton
          color="white_primary"
          component={Link}
          nativeButton={false}
          to={courseClassRepApplyPath(course)}
          variant="contained"
        >
          Learn More
        </CustomColorButton>
      </div>
    </div>
  );
}
